import type { DeepString } from "@/lib/i18n";

/**
 * ThemeToggle — polskie tłumaczenia.
 *
 * `themeName[mode]` — nazwa motywu dla użytkownika (light/dark/funeral/hc).
 * `tooltip(name)` + `ariaLabel(name)` — funkcje substituujące nazwę motywu.
 */
export const pl = {
  themeName: {
    light: "jasny",
    dark: "ciemny",
    funeral: "żałobny",
    hc: "kontrastowy",
  },
  /** title attribute hover'u. */
  tooltip: (name: string) => `Motyw: ${name} (kliknij żeby zmienić)`,
  /** aria-label dla button'a. */
  ariaLabel: (name: string) => `Zmień motyw, obecny: ${name}`,
} as const;

export type ThemeToggleTranslations = DeepString<typeof pl>;
